import * as React from "react";
import {
  CardDescription,
  UsernameCardWrapper,
} from "src/components/shared/Cards/Cards.components";
import {
  SpectatorCardElement,
  SpectatorIcon,
} from "src/components/shared/Cards/SpectatorCard/SpectatorCard.components";
import useIsMobile from "src/hooks/useIsMobile";
interface Props {
  username: string;
}

const SpectatorCard: React.FunctionComponent<Props> = ({ username }) => {
  const isMobile = useIsMobile();
  const maxCharNumber = isMobile ? 6 : 10;

  return (
    <UsernameCardWrapper>
      <SpectatorCardElement data-cy="spectatorCard">
        <SpectatorIcon />
      </SpectatorCardElement>
      <CardDescription>
        {username.length > maxCharNumber
          ? `${username.slice(0, maxCharNumber)}...`
          : username}
      </CardDescription>
    </UsernameCardWrapper>
  );
};

export default SpectatorCard;
